"use client";

// src/flex.tsx
import * as React from "react";
import {
  mergeStyles,
  systemForwardRef,
  Base
} from "@stepstone-genesis/system";
var Flex = systemForwardRef(function Flex2({
  flxType = "flex",
  flxDirection,
  flxWrap,
  flxItems,
  flxContent,
  flxJustify,
  flxFlow,
  flxBasis,
  flxGrow,
  flxShrink,
  flxFlex,
  // @ts-expect-error - we don't want to expose this as public api
  __root,
  ...rest
}, ref) {
  return /* @__PURE__ */ React.createElement(
    Base,
    {
      ref,
      __root: mergeStyles([
        __root,
        {
          display: flxType,
          flexDirection: flxDirection,
          flexWrap: flxWrap,
          alignItems: flxItems,
          alignContent: flxContent,
          flexFlow: flxFlow,
          justifyContent: flxJustify,
          flexBasis: flxBasis,
          flexGrow: flxGrow,
          flexShrink: flxShrink,
          flex: flxFlex
        }
      ]),
      ...rest
    }
  );
});

// src/flex-item.tsx
import * as React2 from "react";
import {
  mergeStyles as mergeStyles2,
  systemForwardRef as systemForwardRef2
} from "@stepstone-genesis/system";
var FlexItem = systemForwardRef2(function FlexItem2({ flxType = "initial", flxOrder, flxSelf, __root, ...rest }, ref) {
  return /* @__PURE__ */ React2.createElement(
    Flex,
    {
      ref,
      __root: mergeStyles2([__root, { order: flxOrder, alignSelf: flxSelf }]),
      flxType,
      ...rest
    }
  );
});
export {
  Flex,
  FlexItem
};
